import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CustomBanner = ({ imageUrl, heading, text, links, loading }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        setImageLoaded(false); // Reset on image change
    }, [imageUrl]);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    // Show skeleton if loading or image not loaded yet
    const showSkeleton = loading || !imageLoaded;

    return (
        <div className="banner-container" style={{ position: 'relative' }}>
            {showSkeleton && (
                <div style={{ position: 'relative', width: '100%', borderRadius: 10, overflow: 'hidden' }}>
                    {/* Image Skeleton */}
                    <Skeleton height={300} width="100%" borderRadius={10} />

                    {/* Heading & Text Skeleton */}
                    <div style={{ padding: '20px' }}>
                        <Skeleton height={30} width="50%" style={{ marginBottom: 10 }} /> {/* Heading */}
                        {text && <Skeleton height={20} width="40%" style={{ marginBottom: 5 }} />} {/* Text */}

                        {/* Links Skeleton */}
                        <div style={{ display: 'flex', gap: '10px', marginTop: 10 }}>
                            {links?.map((_, idx) => (
                                <Skeleton key={idx} height={40} width={120} borderRadius={5} />
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <img
                src={imageUrl}
                alt="Banner"
                className="banner-image"
                style={{ display: imageLoaded ? 'block' : 'none', width: '100%' }}
                onLoad={handleImageLoad}
            />

            {!loading && imageLoaded && (
                <>
                    <div className="banner-overlay" />
                    <motion.div
                        className="banner-text"
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 dangerouslySetInnerHTML={{ __html: heading }} />
                        {text && <p dangerouslySetInnerHTML={{ __html: text }}></p>
                        }
                        {links && (
                            <div className="banner-links">
                                {links.map((link, idx) => (
                                    <Link key={idx} to={link.path}>
                                        {link.label}
                                    </Link>
                                ))}
                            </div>
                        )}
                    </motion.div>
                </>
            )}
        </div>
    );
};

export default CustomBanner;
